import React from "react";
import FileUpload from "../../files/FileUpload";
import ValidatedInputField from "../../common/form/ValidatedInputField";
import VideoSingleUploadRedux from "../../VideoSingleUploadRedux";
import {Field, Fields} from "redux-form";
import Wrapper from "../../common/form/Wrapper";
import FbgAccessContainer from "../../access/FbgAccessContainer";
import MultipleSelectedList from "../../multistep-select/MultipleSelectedList";
import NewsRelations from "../NewsRelations";
import CompanyKeywords from "../CompanyKeywords";
import CompanyKeywordsExtra from "../CompanyKeywordsExtra";
import DropDownOptions from "../../helpers/DropDownOptions";
import ReactSelect from "../../common/ReactSelect";
import KeywordsCountSelect from "../KeywordsCountSelect";
import RteEditor from "../../common/form/RteEditor";
import CompanySpecialBusinessCategories from '../CompanySpecialBusinessCategories';
import RadioGroup from "../../common/form/RadioGroup";
import {subscriptionType} from "../subscriptionType";
import MultiSelect from "../../articles/MultiSelect";
import MultistepSelectFormAdapter from "../../common/MultistepSelectFormAdapter";
import * as subscriptionTypes from '../subscriptionType';

const MAX_KEYWORD_LENGTH = 100;

const ProfileTabContent = props => {
    const {
        labels,
        messages,
        isAdmin,
        maxKeywordsCount,
        keywords,
        keywordsCount,
        companyKeywordsPacks,
        categories,
        specialBusinessCategories,
        initialValues,
        articlesCategories,
        portals,
        onPortalChange,
        regions,
        companyTasks,
        companyCoverRegions
    } = props;

    let imageSizeLimit = (MAX_IMAGE_SIZE > 1) ? MAX_IMAGE_SIZE - 1 : 1;

    return (
        <div>
            <Field
                className="form-control"
                name="name"
                type="text"
                component={ValidatedInputField}
                label={labels.name}
            />
            <div data-cy-company-description>
                <Field
                    type="text"
                    name="description"
                    component={RteEditor}
                    className="form-control"
                    editorName={"companyDescription"}
                />
            </div>

            <KeywordsCountSelect
                isAdmin={isAdmin}
                maxKeywordsCount={maxKeywordsCount}
                keywords={keywords}
                keywordsCount={companyKeywordsPacks}
            />
            <Wrapper label={labels.portal}>
                <Field
                    type="select"
                    name="portal"
                    component={ReactSelect}
                    options={DropDownOptions.getOptions(
                        portals,
                        "value",
                        "label"
                    )}
                    disabled={!isAdmin}
                    onChange={onPortalChange}
                />
            </Wrapper>
            <FbgAccessContainer>
            <Wrapper label={`Abonnementstype`}>
                <div className="col-sm-10">
                    <Field
                        name="subscriptionType"
                        type="input"
                        component={RadioGroup}
                        options={subscriptionType}
                    />
                </div>
            </Wrapper>
            </FbgAccessContainer>
            { ( isAdmin
                || initialValues.subscriptionType == subscriptionTypes.MASKINSTATIONER_REGULAR
                || initialValues.subscriptionType == subscriptionTypes.MASKINSTATIONER_MINI
                || initialValues.subscriptionType == subscriptionTypes.DEALER_TYPE)
                &&
                <Wrapper label="Geolocation til dækning">
                    <Field
                        name="companyCoverRegions"
                        component={MultiSelect}
                        options={DropDownOptions.getOptions(
                            companyCoverRegions,
                            "value",
                            "label"
                        )}
                        disabled={!isAdmin}
                    />
                </Wrapper>
            }
            {(isAdmin
                || initialValues.subscriptionType == subscriptionTypes.MASKINSTATIONER_REGULAR
                || initialValues.subscriptionType == subscriptionTypes.MASKINSTATIONER_MINI)
            &&
            <Wrapper>
                <label className="custom-control custom-checkbox">
                    <Field
                        name="dmogeMember"
                        type="checkbox"
                        component="input"
                        className="custom-control-input"
                    />
                    <span className="custom-control-indicator"> </span>
                    <span className="custom-control-description">Medlem af DME <small>(Kun for maskinstationer)</small>
                    </span>
                </label>
            </Wrapper>
            }
            {(isAdmin
                || initialValues.subscriptionType == subscriptionTypes.MASKINSTATIONER_REGULAR
                || initialValues.subscriptionType == subscriptionTypes.MASKINSTATIONER_MINI)
            &&
            <Field
                label={
                    <span>
                        Opgaver <small className="form-text text-muted">(Kun for maskinstationer)</small>
                    </span>
                }

                name="companyTaskIds"
                data={companyTasks}
                placeholder={"Vælg..."}
                disableParentSelect={true}
                disabled={false}
                format={null}
                component={MultistepSelectFormAdapter}
            />
            }
            <Field
                name="keywords"
                component={CompanyKeywords}
                data={categories}
                isAdmin={isAdmin}
                maxCount={parseInt(maxKeywordsCount)}
                maxCreatableLength={MAX_KEYWORD_LENGTH}
                placeholder={"Vælg fra branche liste"}
                selectedListComponent={MultipleSelectedList}
                outputValuesKey={"name"}
            />
            {isAdmin &&
            <Field
                name="keywordsExtra"
                component={CompanyKeywordsExtra}
                selectedListComponent={MultipleSelectedList}
                outputValuesKey={"name"}
            />
            }
            <FbgAccessContainer>
                <Field
                    name="specialBusinessCategories"
                    component={CompanySpecialBusinessCategories}
                    categories={specialBusinessCategories}
                    placeholder={"Speciel branche kategori"}
                />
            </FbgAccessContainer>
            <Field
                type="select"
                name="articlesCategories"
                component={NewsRelations}
                options={articlesCategories}
                labelName={labels.articlesCategories}
            />
            <FbgAccessContainer>
                <Field
                    className="form-control"
                    name="recruiterId"
                    component={ValidatedInputField}
                    type="number"
                    disabled={!isAdmin}
                    hint={
                        <small>
                            {labels.companyRecruiterIdHint}
                            &nbsp;<a
                                href={"http://www.branchejob.dk"}
                                target="_blank"
                            >
                                http://www.branchejob.dk
                            </a>
                        </small>
                    }
                    label={labels.recruiterId}
                />
            </FbgAccessContainer>
            <Wrapper
                label={
                    <span>
                        {labels.logo}
                        <span className="text-muted">
                            {" " + messages.optional}
                        </span>
                        <small className="form-text text-muted">
                            {`${labels.fileMaxSize} ${imageSizeLimit} MB.`}
                        </small>
                    </span>
                }
                inputCol="10"
            >
                <Fields
                    type="file"
                    names={["images", "defaultImages", "defaultImageIds"]}
                    component={FileUpload}
                    props={{
                        postUrl: "api/privateV1/companies/validate-images",
                        maxFiles: 1,
                        type: "image",
                    }}
                />
            </Wrapper>
            <Wrapper
                label={
                    <span>
                        {labels.images}
                        <span className="text-muted">
                            {" " + messages.optional}
                        </span>
                        <small className="form-text text-muted">
                            {`${labels.fileMaxSize} ${imageSizeLimit} MB.`}
                        </small>
                    </span>
                }
                inputCol="10"
            >
                <Fields
                    type="file"
                    names={["imagesExtra", "defaultImagesExtra", "defaultImageIdsExtra"]}
                    component={FileUpload}
                    props={{
                        postUrl: "api/privateV1/companies/validate-images",
                        type: "image",
                        dropzoneId: 'Extra'
                    }}
                    /*
                        "dropzoneId" - defines a group of images to be shown in a specific
                            dropzone component in a form, if the form has several dropzones.
                            Is stored in the DB.
                            Currently is only for the components with type:"image", not in use for type:"file".
                        "names" - must be like
                            "images<dropzoneId>", "defaultImages<dropzoneId>", "defaultImageIds<dropzoneId>".
                        For the first dropzone or if a form has only one dropzone, the "dropzoneId" property
                            is not needed and names must be "images", "defaultImages", "defaultImageIds".
                    */
                />
            </Wrapper>
            <Fields
                type="text"
                names={[
                    "youtubeId",
                    "vimeoId",
                    "vimeoName",
                    "vimeoDescription"
                ]}
                component={VideoSingleUploadRedux}
                props={{
                    youtubeText: labels.youtube,
                    companyId: initialValues.id
                }}
            />
        </div>
    );
};

export default ProfileTabContent;



// WEBPACK FOOTER //
// ./web/src/components/company/company-form/ProfileTabContent.jsx